import { useCallback } from 'react'
import { supabase } from '../lib/supabaseClient'
import { useAuth } from '../contexts/AuthContext'
import { useProfile } from './useProfile'

// Reads templates from user_profiles.workout_templates JSONB and exposes a
// setter that upserts the column. Mirrors the existing useProfile pattern.
export function useWorkoutTemplates() {
  const { user } = useAuth()
  const { profile, refetch } = useProfile()

  const templates = profile?.workout_templates || {
    day1_chest_back: [],
    day2_arms_shoulders: [],
    day3_legs: [],
  }

  const setTemplate = useCallback(async (day, exerciseIds) => {
    if (!user) return false
    const next = { ...(profile?.workout_templates || {}), [day]: exerciseIds }
    const { error: err } = await supabase
      .from('user_profiles')
      .upsert(
        { user_id: user.id, workout_templates: next, updated_at: new Date().toISOString() },
        { onConflict: 'user_id' }
      )
    if (err) return false
    await refetch()
    return true
  }, [user, profile, refetch])

  return { templates, setTemplate }
}
